import { Effect } from 'effect';

import { subscribeNewsletter as subscribeNewsletterApi } from '../../bind/customer';
import { createFormSubmittedPayload } from '../../utils/gtm/create/form-submitted';
import { sendGtmEvent } from '../../utils/gtm/gtm';

export default function subscribeNewsletter(email: string) {
  return Effect.gen(function* () {
    const response = yield* subscribeNewsletterApi(email);

    // Send GTM form_submitted event
    yield* createFormSubmittedPayload('Newsletter', email).pipe(Effect.flatMap(sendGtmEvent));

    return response;
  });
}
